module.exports = __webpack_public_path__ + "img/car.56455fa1.png";